import { useMemo } from "react";
import {
  useGetGoodProfileListQuery,
  useGetReceiverListWithStorageFacilitiesQuery,
} from "../../../../graphql/generated";
import TrailerCompartmentAssignmentForm, {
  TrailerCompartmentAssignmentFormProps,
} from "./TrailerCompartmentAssignmentForm";
import { useOrgSettings } from "../../../account/Access/OrgSettingsGuard";
import { CompartmentVolume } from "../../../common/CompartmentGraphic/CompartmentGraphic";

type TrailerCompartmentAssignmentFormContainerProps = Omit<
  TrailerCompartmentAssignmentFormProps,
  "receivers" | "goodProfiles"
>;

const EMPTY_ARRAY: never[] = [];

const TrailerCompartmentAssignmentFormContainer: React.FC<TrailerCompartmentAssignmentFormContainerProps> =
  (props) => {
    const receiversListWithStorageFacilitiesQuery =
      useGetReceiverListWithStorageFacilitiesQuery();

    const goodProfilesQuery = useGetGoodProfileListQuery({ includeInactive: true });

    const receivers = useMemo(
      () =>
        receiversListWithStorageFacilitiesQuery.data?.businessEntities.data ||
        EMPTY_ARRAY,
      [receiversListWithStorageFacilitiesQuery.data]
    );

    const goodProfiles = useMemo(
      () => goodProfilesQuery.data?.goodProfiles.data || EMPTY_ARRAY,
      [goodProfilesQuery.data]
    );
    const orgSettings = useOrgSettings();
    const trackCommodity = orgSettings?.dispatching?.trackCommodity === true;

    // Map trailer's compartmentVolumes to the CompartmentVolume shape when
    // trackCommodity is enabled.
    const compartmentVolumes: CompartmentVolume[] | undefined = trackCommodity
      ? (props.trailer.compartmentVolumes ?? []).map((cv) => ({
          _id: cv._id ? String(cv._id) : undefined,
          compartmentId: cv.compartmentId,
          trailerId: String(props.trailer._id),
          commodityId: cv.commodityId ?? undefined,
          quantity: cv.quantity,
          lastUpdated: cv.lastUpdated ?? null,
          lastShipmentId: cv.lastShipmentId ? String(cv.lastShipmentId) : null,
          lastShipmentNumber: cv.lastShipmentNumber ?? null,
          updatedBy: cv.updatedBy ?? null,
        }))
      : undefined;

    return (
      <TrailerCompartmentAssignmentForm
        receivers={receivers}
        goodProfiles={goodProfiles}
        compartmentVolumes={compartmentVolumes}
        onEditVolume={undefined}
        hideVolumeMetadata
        {...props}
      />
    );
  };

export default TrailerCompartmentAssignmentFormContainer;
